import { Form } from "antd";

import ExportButton from "@/components/Export/ExportButton";

import FilterSelect from "./FilterSelect";
import { useFilters } from "./hooks/useFilters";

const ExportAsset = () => {
  const [params, setFilters] = useFilters();

  return (
    <Form layout="vertical">
      <FilterSelect
        model="assets"
        onChange={(value) => setFilters("id", value)}
      />
      <FilterSelect
        model="assetTypes"
        onChange={(value) => setFilters("asset_type_id", value)}
      />
      <FilterSelect
        model="locations"
        onChange={(value) => setFilters("location_id", value)}
      />
      <FilterSelect
        model="organizations"
        onChange={(value) => setFilters("location.organization_id", value)}
      />
      <ExportButton model="assets" params={params} />
    </Form>
  );
};

export default ExportAsset;
